<div class="planning-booking-reminder" *ngIf="activeBookingsNum >= 1"
     (click)="openUserBookings()">
  {{ 'YOU_HAVE_X_ACTIVE_BOOKINGS' | translate | sprintf:activeBookingsNum}}. <span class="htz-txt-underline">{{'OPEN' | translate}}</span>
</div>
